import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import FaqSection from "../FaqPage/FaqSection";
import Scrollbar from "../../components/scrollbar/scrollbar";

const FaqPage = ({ showTitle = true }) => {
  return (
    <Fragment>
      {/* Inline CSS */}
      <style>
        {`
        @media (max-width: 991px) {
          .faq-pg-section {
            padding: 40px 0 !important; /* reduced from section-padding (~80-100px) */
          }
        }
        `}
      </style>

      {showTitle && <PageTitle pageTitle="FAQ" pagesub="FAQ" />}

      <section className="faq-pg-section section-padding bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col col-xl-6 col-lg-8 col-md-10 col-12">
              <div className="section-title-s3">
                <h2 className="text-uppercase text-primary fw-bold text-center">
                  Frequently Asked Question
                </h2>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col col-xs-12 col-lg-10">
              <div
                className="panel-group faq-accordion theme-accordion-s1"
                id="accordion"
              >
                <FaqSection />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Scrollbar />
    </Fragment>
  );
};

export default FaqPage;
